import { customerFragment } from '@/hooks/shopify-hooks/fragments/b2bCustomer/customerFragment';
import { useCustomerApi,useGetCustomerProductsApi } from '@/hooks/shopify-hooks/useShopifyUtils';
import { customerAddressFragment } from '@/hooks/shopify-hooks/fragments/b2bCustomer/customerAddressFragment';
import { shopifyConst } from '@/hooks/shopify-hooks/useShopifyConst.js';
const { c4aOAuth2State } = shopifyConst;
const c4aOAuth2StateNew = c4aOAuth2State === 'true' ? true : false;

// 查询customer
export const fetchCustomer = async (accessToken) => {
  try {
    const query = `
      query customer {
        customer {
          ...CustomerFragment
          emailAddress {
            emailAddress
            marketingState
          }
        }
      }
      ${customerFragment}
    `;
    const variables = {};
    let response 
    if(c4aOAuth2StateNew){
       response = await useCustomerApi(accessToken, query, variables,'customer');
    }else {

      response = await useCustomerApi(accessToken, query, variables);
    }
    
    // const response = JSON.parse(res.data.value);
    if(c4aOAuth2StateNew && response?.errors && response?.errors?.[0]?.message) {
      //  response = await ATTtoken();
      //  fetchCustomer(useGetStorage(_CSR_ACCESS_TOKEN))
      return
    } else {
      if (response?.errors) {
        if (response?.errors?.[0]?.message) {
          throw new Error(response.errors[0].message);
        }
  
        throw new Error('Unnable to fetch Customer');
      }
    }
    const rescustomer = response?.data?.customer
    rescustomer?.addresses?.edges?.forEach(item => {
      item.node.provinceCode =  item.node.provinceCode || item.node.zoneCode
    });
    return rescustomer;
  } catch (e) {
    console.error(e);
  }
}

// 更新customer
export const customerUpdate = async (customerModel, accessToken) => {
  try {
    const query = `      
      mutation customerUpdate($input: CustomerUpdateInput!) {
        customerUpdate(input: $input) {   
          customer {
            ...CustomerFragment
          }       
          userErrors {
            code
            field
            message
          }
        }
      }
      ${customerFragment}
    `;
    const variables = {
      input: customerModel
    };
    // let varis  = JSON.stringify(variables)
    // console.log('variablesvaris',varis)
    // if(c4aOAuth2StateNew){
    //   variables = await encryptData(varis)
    // }
    console.log('variables',variables)

    const response = await useCustomerApi(accessToken, query, variables);
    // const response = JSON.parse(res.data.value);

    if (response?.errors) {
      if (response?.errors?.[0]?.message) {
        throw new Error(response.errors[0].message);
      }

      throw new Error('Unable to update customer');
    }

    return response?.data?.customerUpdate;
  } catch (e) {
    console.error(e);
  }
}

// 创建customer地址
export const customerAddressCreate = async (address, defaultAddress, accessToken) => {
  try {
    const query = `
    mutation customerAddressCreate($address: CustomerAddressInput!, $defaultAddress: Boolean) {
      customerAddressCreate(address: $address, defaultAddress: $defaultAddress) {
        customerAddress {
          ...CustomerAddressFragment
        }
        userErrors {
          code
          field
          message
        }
      }
    }
    ${customerAddressFragment}
    `;
    // address.zoneCode = 'AL'
    const variables = {
        address,
        defaultAddress
    };
    console.log('accessTokenaccessToken',accessToken)
    const response = await useCustomerApi(accessToken, query, variables,'address');
    // const response = JSON.parse(res.data.value);

    if (response?.errors) {
      if (response?.errors?.[0]?.message) {
        throw new Error(response.errors[0].message);
      }

      throw new Error('Unnable to fetch Customer');
    }

    return response?.data?.customerAddressCreate;
  } catch (e) {
    console.error(e);
  }
}

// 删除customer地址
export const customerAddressDelete = async (addressId, accessToken) => {
  try {
    const query = `
    mutation customerAddressDelete($addressId: ID!) {
      customerAddressDelete(addressId: $addressId) {
        deletedAddressId
        userErrors {
          code
          field
          message
        }
      }
    }
    `;
    const variables = {
        addressId
    };
    const response = await useCustomerApi(accessToken, query, variables,'address');
    // const response = JSON.parse(res.data.value);

    if (response?.errors) {
      if (response?.errors?.[0]?.message) {
        throw new Error(response.errors[0].message);
      }

      throw new Error('Unable to fetch Customer');
    }

    return response?.data?.customerAddressDelete;
  } catch (e) {
    console.error(e);
  }
}

// 更新customer地址
export const customerAddressUpdate = async (address, addressId, defaultAddress, accessToken) => {
  try {
    const query = `
    mutation customerAddressUpdate($addressId: ID!, $address: CustomerAddressInput!, $defaultAddress: Boolean) {
      customerAddressUpdate(addressId: $addressId, address: $address, defaultAddress: $defaultAddress) {
        customerAddress {
          ...CustomerAddressFragment
        }
        userErrors {
          code
          field
          message
        }
      }
    }
    ${customerAddressFragment}
    `;
    const variables = {
        addressId,
        address,
        defaultAddress
    };
    const response = await useCustomerApi(accessToken, query, variables);
    // const response = JSON.parse(res.data.value);

    if (response?.errors) {
      if (response?.errors?.[0]?.message) {
        throw new Error(response.errors[0].message);
      }

      throw new Error('Unnable to fetch Customer');
    }

    return response?.data?.customerAddressUpdate;
  } catch (e) {
    console.error(e);
  }
}

// 获取customer产品
export const customerProductFetch = async (accessToken,location) => {
  try {

    const response = await useGetCustomerProductsApi(accessToken, location);

    if (response?.errors) {
      if (response?.errors?.[0]?.message) {
        throw new Error(response.errors[0].message);
      }

      throw new Error('Unable to fetch Customer Product');
    }

    return response?.data;
  } catch (e) {
    console.error(e);
  }
}


export const b2bCustomerApi = {
  fetchCustomer,
  customerUpdate,
  customerAddressCreate,
  customerAddressUpdate,
  customerAddressDelete,
  customerProductFetch
}